const RANKING = [
  { rank: 1, title: '反派千金的重生逆袭', type: '韩漫', hot: '🔥 9.6', update: '今日更新', change: 'up' },
  { rank: 2, title: '剑尊归来之无双天下', type: '国漫', hot: '🔥 9.7', update: '昨日更新', change: 'up' },
  { rank: 3, title: '灵笼：末世生存法则', type: '国漫', hot: '⭐ 9.5', update: '2天前', change: 'same' },
  { rank: 4, title: '异世界悠闲 farming 生活', type: '日漫', hot: '⭐ 9.3', update: '今日更新', change: 'up' },
  { rank: 5, title: '社内恋爱禁止令', type: '韩漫', hot: '⭐ 9.1', update: '昨日更新', change: 'down' },
  { rank: 6, title: '勇者退休后的慢生活', type: '日漫', hot: '⭐ 8.9', update: '3天前', change: 'same' },
];

const CHANGE_ICON: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-600',
  down: 'ri-arrow-down-line text-red-400',
  same: 'ri-subtract-line text-foreground-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          人气排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时热门漫画榜单，看看大家都在追什么
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden">
            {RANKING.map((item, i) => (
              <div
                key={item.title}
                className={`flex items-center gap-4 px-5 py-4 ${
                  i < RANKING.length - 1 ? 'border-b border-background-100' : ''
                } hover:bg-background-100/50 transition-colors cursor-pointer`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold font-heading whitespace-nowrap ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.update}</span>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs font-medium text-primary-500 whitespace-nowrap">{item.hot}</span>
                  <span className={`w-5 h-5 flex items-center justify-center ${CHANGE_ICON[item.change]}`}></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}